import { IonContent, IonPage, IonTitle } from '@ionic/react';
import { ReactElement } from 'react';
import { useParams } from 'react-router';
import { Machine, useGetMachineQuery } from '../../api/graphql/generated';
import { NestedPageHeader } from '../../components/header/page.header';
import { MachineProgramStatus } from '../../components/machine/machine-program-status';
import { MachineRealtime } from '../../components/machine/machine-realtime';
import { useBeaconRouter } from '../../route/route.hooks';
import { MachineContextProvider } from './machine-context-provider';

interface RouteParams {
  id: string;
}

interface MachineRealtimePageProps {
  teamId: string;
}

const MachineRealtimePage = (props: MachineRealtimePageProps): ReactElement => {
  const { teamId } = props;

  const params = useParams<RouteParams>();
  const { id } = params;

  const { data } = useGetMachineQuery({
    variables: { input: { id, teamId } },
  });

  const { builder } = useBeaconRouter();

  const machine: Machine | undefined = data?.getMachine;

  return (
    <MachineContextProvider machineId={id} teamId={teamId}>
      <IonPage>
        <NestedPageHeader
          defaultBackRoute={builder.getMachineRoute(teamId, id)}
        >
          <IonTitle>
            {machine?.name}
            <div className="subtitle header-program-status">
              <MachineProgramStatus machine={machine} />
            </div>
          </IonTitle>
        </NestedPageHeader>
        <IonContent>
          <MachineRealtime machine={machine} />
        </IonContent>
      </IonPage>
    </MachineContextProvider>
  );
};

export { MachineRealtimePage };
